import { useEffect } from 'react';
import { get } from 'lodash';

export default function useOnInit({
  inputName,
  shouldShowScale,
  shouldShowValue,
  step,
  min,
  max,
  ticks,
  rtl,
}) {
  useEffect(() => {
    const $slider = $(`#${inputName}`);

    // added extra logging for issue NET-1000
    Raven.captureBreadcrumb({
      message: 'sliderTemplate init started',
      category: 'sliderTemplate',
      data: {
        slideQuestionDto: {
          shouldShowScale,
          shouldShowValue,
          step,
          min,
          max,
          ticks,
        },
        rtl,
      },
    });

    $slider.slider({
      highlight: true,
      rtl,
    });

    const sliderContainer = $('.scale-container');
    const parentWidth = sliderContainer.parent().width();
    let stepWidth;
    try {
      const sliderStepClientRects = sliderContainer
        .find('.scale-steps .scale-step')
        .get(1)
        .getClientRects();
      stepWidth = get(sliderStepClientRects, '[0].width', 0);
    } catch (e) {
      Raven.captureException('sliderTemplate init error', {
        extra: {
          get: sliderContainer.find('.scale-steps .scale-step').get(1)
            .outerHTML,
          getClientRects: JSON.stringify(
            sliderContainer
              .find('.scale-steps .scale-step')
              .get(1)
              .getClientRects(),
          ),
        },
      });
    }
    $slider.on('change', (event) => {
      const { value } = event.target;
      const { left } = $('.ui-slider-handle').get(0).style;
      toggleActiveStepClasses(value);

      // get the number of pixels that we should move to the left
      const pixelStep = ((value - min) / event.target.step) * stepWidth;

      let offsetPercent;
      if (rtl) {
        offsetPercent = 100 - parseInt(left.replace('%', ''), 10);
      } else {
        offsetPercent = parseInt(left.replace('%', ''), 10);
      }

      // get the number of pixels that the handle has moved to the right
      const relativePositionConstant = (offsetPercent * parentWidth) / 100;
      // I have no idea why this works or is needed.
      const correctionMagicNumber = (offsetPercent / 100) * 32;
      // Subtract the number of pixels to the left the scale should make with the number of
      // pixels the handler went to the right, to keep them in the same position. Also use
      // the magic correction number which no one could figure out why this was needed.
      // If you, reading this, can explain it better please by all means do.
      const newOffset =
        pixelStep - (relativePositionConstant - correctionMagicNumber);

      if (!rtl && newOffset >= 0) {
        $('#js-scale-container').css('left', `-${newOffset}px`);
      } else if (rtl && newOffset >= 0) {
        $('#js-scale-container').css('right', `-${newOffset}px`);
      }

      $('#js-slider-value').html(value);
    });

    $slider.on('slidestop', () => {
      const selectedValue = $('#slider').val();
      const $elements = $('.answers .answer').filter(function filterAnswers() {
        return $.trim($(this).text()) === selectedValue;
      });
      $elements.tap();
    });

    return () => {
      const $sliderContainer = $(`#${inputName}`);
      $sliderContainer.off('change slidestop');
      $('#sliderContainer').html('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

function toggleActiveStepClasses(activeValue) {
  $('.scale-step.close').removeClass('close');
  $('.scale-step.closer').removeClass('closer');
  $('.scale-step.active').removeClass('active');
  const currentElement = $(`.scale-step--${activeValue}`);
  $('.scale-label.active').removeClass('active');
  $(`.scale-label--${activeValue}`).addClass('active');
  currentElement.addClass('active');
  currentElement
    .prev()
    .prev()
    .addClass('close');
  currentElement.prev().addClass('closer');
  currentElement
    .next()
    .next()
    .addClass('close');
  currentElement.next().addClass('closer');
}
